export default "__VITE_ASSET__CtPkeUK5__"